import axios from "axios";
import swal from "sweetalert";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import {
	changeAdminRules,
	loginConfirmedAction,
	Logout,
	setLang,
} from "../store/actions/AuthActions";

const tokenKey = "token";

export function login(email, password) {
	const postData = { email, password };
	return axios.post(`${API_BASE_URL_ENV()}/auth/admin/login`, postData);
}

export function formatError(errorResponse) {
	switch (errorResponse?.message) {
		case "EMAIL_EXISTS":
			//return 'Email already exists';
			swal("Oops", "Email already exists", "error");
			break;
		case "User not Exist.":
			swal("Oops", "Email not found", "error", { button: "Try Again!" });
			break;
		case "Incorrect Password.":
			//return 'Invalid Password';
			swal("Oops", "Incorrect Password", "error", { button: "Try Again!" });
			break;
		case "كلمة سر خاطئة":
			//return 'Invalid Password';
			swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
			break;
		case "USER_DISABLED":
			return "User Disabled";
		default:
			return "";
	}
}

export function getJwt() {
	return localStorage.getItem(tokenKey);
}

export function saveTokenInLocalStorage(tokenDetails) {
	localStorage.setItem("SyntaxHrAdmin", JSON.stringify(tokenDetails));
	localStorage.setItem(tokenKey, tokenDetails.tokens?.access?.token);
	localStorage.setItem(
		"SyntaxHrAdminRules",
		JSON.stringify(tokenDetails.user.role?.permissions) //?.map((item) => item.role)
	);
}

export function checkAutoLogin(dispatch, navigate) {
	const tokenDetailsString = localStorage.getItem("SyntaxHrAdmin");
	const adminRules = localStorage.getItem("SyntaxHrAdminRules");
	const adminLang = localStorage.getItem("SyntaxHrLang");
	let tokenDetails = "";

	if (!tokenDetailsString || !adminRules) {
		dispatch(Logout(navigate));
		return;
	}

	tokenDetails = JSON.parse(tokenDetailsString);
	let rules = JSON.parse(adminRules);
	dispatch(loginConfirmedAction(tokenDetails));
	dispatch(changeAdminRules(rules));

	if (adminLang === "en") {
		dispatch(setLang("en"));
	} else {
		dispatch(setLang("ar"));
	}
}
